import { combineReducers } from 'redux';
import { authReducer } from '../auth';
import { projectReducer } from '../projects';
import { taskReducer } from '../tasks';
import { tagReducer } from '../tags';
import { commentReducer } from '../comments';
import { dashboardReducer } from '../dashboard';
import { userReducer } from '../users';
import { laborReducer } from '../labor';
import { httpRequestsOnLoadReducer } from '../http_requests_on_load';
import { httpRequestsOnSuccessReducer } from '../http_requests_on_success';
import { httpRequestsOnErrorsReducer } from '../http_requests_on_errors';

export const appReducer = combineReducers({
  auth: authReducer,
  projects: projectReducer,
  tasks: taskReducer,
  tags: tagReducer,
  comments: commentReducer,
  dashboard: dashboardReducer,
  users: userReducer,
  labor: laborReducer,
  httpOnLoad: httpRequestsOnLoadReducer,
  httpOnSuccess: httpRequestsOnSuccessReducer,
  httpOnError: httpRequestsOnErrorsReducer,
});
